const observed = new WeakSet();

const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const observer = reducedMotion
  ? null
  : new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('ms-is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

function initializeMobiustreamHome(root = document) {
  const home = root.matches?.('.ms-home') ? root : root.querySelector?.('.ms-home');
  if (!home) return;

  if (!reducedMotion) home.classList.add('ms-motion-ready');

  home.querySelectorAll('.ms-reveal').forEach((element) => {
    if (observed.has(element)) return;
    observed.add(element);

    if (reducedMotion || !observer) {
      element.classList.add('ms-is-visible');
      return;
    }

    observer.observe(element);
  });
}

initializeMobiustreamHome();

document.addEventListener('shopify:section:load', (event) => {
  initializeMobiustreamHome(event.target);
});
